module.exports = __webpack_public_path__ + "static/img/icon_jc.278e0160.png";